import React from 'react'
import { Link as RouterLink, NavLink } from 'react-router-dom'
import { Link as PrismicLink } from 'prismic-reactjs'
import { linkResolver } from '../../prismic-configuration'
import { getTypeFormUrlWithParams, openTypeFormPopup } from '../../utils/helpers'

// A factoriser
const scrollToBottom = (e) => {
  e.preventDefault(); // empêche le "jump en haut"
  const footer = document.getElementById("footersite");
  if (footer) {
    footer.scrollIntoView({ behavior: "smooth" });
  }
  else {
    window.scrollTo({
      top: document.documentElement.scrollHeight, // hauteur max du document
      behavior: "smooth", // défilement fluide
    });
  }
};
// ---

const DataLink = React.forwardRef(({ prismicLink, children, ...rest }, ref) => {

  if (prismicLink && (prismicLink.link_type === 'Document' || prismicLink.type)) {
    if (prismicLink.id) {
      const Component = rest.activeClassName ? NavLink : RouterLink
      const to = prismicLink.link_type ? PrismicLink.url(prismicLink, linkResolver) : linkResolver(prismicLink)
      const contientPDF = to.toLowerCase().includes("pdf");
      return <Component ref={ref} {...rest} to={to} target={contientPDF ? "_blank": ""}>{children}</Component>
    }
    const props = { ...rest }
    delete props.exact
    delete props.activeClassName

    return <span {...props}>{children}</span>
  }

  const props = { ...rest }
  delete props.exact
  delete props.activeClassName

  props.href = prismicLink && prismicLink.url

  const contientPDF = prismicLink && prismicLink.url && prismicLink.url.toLowerCase().includes("pdf") == true;

  if (prismicLink && prismicLink.url)
  {
    if (prismicLink.url.indexOf('.typeform.com/to/') > -1) {
      props.href = getTypeFormUrlWithParams(prismicLink.url)
      props.onClick = (e) => {
        e.preventDefault()
        openTypeFormPopup(e.currentTarget.href)
      }
    }
    else if (prismicLink.url.indexOf('.mca-groupe.com/API/public/index.php/PUBLIC/FORM/') > -1) { // A voir pour l'améliorer
      props.href = getTypeFormUrlWithParams(prismicLink.url)
      props.onClick = (e) => {
        e.preventDefault()
        openTypeFormPopup(e.currentTarget.href)
      }
    }
  }
  
  if (prismicLink.url !== "#")
  {
    return (
      <a
        ref={ref}
        target={contientPDF ? "_blank" : (prismicLink && prismicLink.target ? prismicLink.target : '')}
        rel={prismicLink && prismicLink.target ? 'noopener' : ''}
        {...props}
      >
        {children}
      </a>
    )
  }
  else
  {
    return (
      <a
        ref={ref}
        rel={prismicLink && prismicLink.target ? 'noopener' : ''}
        {...props}
        onClick={scrollToBottom}
      >
        {children}
      </a>
    )
  }
})

export default DataLink
